import React from "react";
import { Tabs, Tab } from "@mui/material";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

type Props = {
  value: ContentLanguage;
  onChange: (lang: ContentLanguage) => void;
};

export function LanguageTabs({ value, onChange }: Props) {
  return (
    <Tabs
      value={value}
      onChange={(_, newValue: ContentLanguage) => onChange(newValue)}
      sx={{
        mb: 0,
        "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
        "& .Mui-selected": { color: "primary.main" },
        "& .MuiTabs-indicator": { backgroundColor: "primary.main" },
      }}
    >
      <Tab label="Deutsch" value="de" />
      <Tab label="English" value="en" />
    </Tabs>
  );
}
